import React, { Component } from "react";
import "./NodeManager.css";
import NetworksDashboard from "./NetworksDashboard";
import OrganizationDashboard from "./OrganizationDashboard";
import AccessDashboard from "./AccessDashboard";
import Header from "./Header";
import NetworkPage from "./NetworkPage";
import NetworkInfo from "./NetworkInfo";
import SideBar from "./SideBar";
import { withRouter } from "react-router";
import ReactNotification from "react-notifications-component";
import { BrowserRouter as Switch, Route } from "react-router-dom";
import axios from "axios";

class NodeManager extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isStaff: false,
      demoMode: this.getCookie("demoMode") ? this.getCookie("demoMode") === "true" : false,
    };
  }

  getCookie(name) {
    let value = `; ${document.cookie}`;
    let parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  getUserInfo = () => {
    axios
      .get(this.props.baseUrl + "/api/api/users/me/", {
        headers: this.getHeaders(),
      })
      .then((res) => {
        this.setState({ isStaff: res.data.is_staff });
      })
      .catch((err) => {});
  };

  getHeaders = () => {
    return {
      Authorization: `Token ${this.props.token}`,
    };
  };
  componentDidMount() {
    this.getUserInfo();
  }
  render() {
    return (
      <main className="content">
        <Header
          baseDir={this.props.baseDir}
          user={this.props.user}
          setToken={this.props.setToken}
          removeCookie={this.props.removeCookie}
          demoMode={this.state.demoMode}
        />
        <div className="app_page">
          <ReactNotification />
          <Switch>
            <Route exact path={this.props.baseDir}>
              <SideBar baseDir={this.props.baseDir} isStaff={this.state.isStaff} page="Networks" />
              <NetworksDashboard
                baseUrl={this.props.baseUrl}
                baseDir={this.props.baseDir}
                token={this.props.token}
                user={this.props.user}
              />
            </Route>
            <Route exact path={this.props.baseDir+"/networks"}>
              <SideBar baseDir={this.props.baseDir} isStaff={this.state.isStaff} page="Networks" />
              <NetworksDashboard
                baseUrl={this.props.baseUrl}
                baseDir={this.props.baseDir}
                token={this.props.token}
                user={this.props.user}
              />
            </Route>
            <Route exact path="/*/networks/:networkUUID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/access">
              <SideBar baseDir={this.props.baseDir} isStaff={this.state.isStaff} page="Networks" />
              <NetworkInfo
                baseDir={this.props.baseDir}
                baseUrl={this.props.baseUrl}
                token={this.props.token}
                user={this.props.user}
              />
            </Route>
            <Route
              exact path="/*/networks/:networkUUID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/:nodeId(\d+)/"
            >
              <SideBar baseDir={this.props.baseDir} isStaff={this.state.isStaff} page="Networks" />
              <NetworkPage
                baseDir={this.props.baseDir}
                baseUrl={this.props.baseUrl}
                token={this.props.token}
                user={this.props.user}
              />
            </Route>
            <Route exact path="/*/networks/:networkUUID(\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b)/">
              <SideBar baseDir={this.props.baseDir} isStaff={this.state.isStaff} page="Networks" />
              <NetworkPage
                baseDir={this.props.baseDir}
                baseUrl={this.props.baseUrl}
                token={this.props.token}
                user={this.props.user}
              />
            </Route>
            <Route exact path={this.props.baseDir+"/organization"}>
              <SideBar baseDir={this.props.baseDir} isStaff={this.state.isStaff} page="Organization" />
              <OrganizationDashboard
                baseUrl={this.props.baseUrl}
                token={this.props.token}
                user={this.props.user}
              />
            </Route>
            <Route exact path={this.props.baseDir+"/access"}>
              <SideBar baseDir={this.props.baseDir} isStaff={this.state.isStaff} page="Beta Access" />
              <AccessDashboard
                baseUrl={this.props.baseUrl}
                token={this.props.token}
                user={this.props.user}
              />
            </Route>
          </Switch>
        </div>
      </main>
    );
  }
}

export default withRouter(NodeManager);
